import { Controller } from "@hotwired/stimulus"

/**
 * Generic remove interaction for BadgeComponent, which can be used if @close: true
 * – Requires a key, label pair
 * – Emits  badge:removed event with those two values, and then removes itself.
 * – Configure network interaction elsewhere (i.e. actual request to remove value)
 */

export default class extends Controller {
  static values = { key: String, label: String }

  remove () {
    this.dispatch("removed", {
      detail: { key: this.keyValue, label: this.labelValue },
      bubbles: true
    })
    this.element.remove()
  }
}
